import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom'

import Logo from '../components/logo'
import Popup from '../components/popup';
import DropdownInput from '../components/dropdownInput';

import iconEye from '../assets/Iconly/eye.svg'
import iconEyeClosed from '../assets/Iconly/eye-closed.svg'

import config from '../config';
import { useHttp } from '../hooks/http.hook'
import { AuthContext } from '../context/AuthContext'
import { homeForRole, MEDIA_MANAGER_ROLE } from '../utils/access'


const Splash = () => {
  const auth = useContext(AuthContext)
  // console.log('AUTH:', auth)
  const navigate  = useNavigate()
  const [searchParams] = useSearchParams();
  const {request} = useHttp()

  const getWindowSize = () => ({
    width: window.innerWidth,
    height: window.innerHeight
  });
  
  const [windowSize, setWindowSize] = useState(getWindowSize);
  
  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getWindowSize());
    };
  
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Redirect already logged-in users to their home page
  useEffect(() => {
    if (auth.isAuthenticated && auth.authData?.user?.usertype_id) {
      const userTypeId = auth.authData.user.usertype_id;
      
      navigate(homeForRole(userTypeId), { replace: true });
    }
  }, [auth.isAuthenticated, auth.authData, navigate]);

  const [credentials, setCredentials] = useState({ email:'', password:'' })
  const [signupData, setSignupData] = useState({ firstName:'', lastName:'', terminal:'', password:'' })
  const [prefilledEmail, setPrefilledEmail] = useState('');
  const [invitedRole, setInvitedRole] = useState(null);
  const invitation = searchParams.get('invite') || '';
  const needsTerminal = !prefilledEmail || ![1, 3, MEDIA_MANAGER_ROLE].includes(Number(invitedRole));
  const [invitedTerminalId, setInvitedTerminalId] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    // console.log('\nname, value:', name, value)
    setCredentials({ ...credentials, [name]: value });
  }
  // useEffect(()=>{console.log(credentials)}, [credentials])
  const handleSignupChange = (event) => {
    const { name, value } = event.target;
    // console.log('\nname, value:', name, value)
    setSignupData({ ...signupData, [name]: value });
  }
  // useEffect(()=>{console.log(credentials)}, [credentials])

  const [showPassword, setShowPassword] = useState(false)
  const handlePassMode = () => {
    setShowPassword(!showPassword)
  }
  // useEffect(()=>{console.log('showPassword:', showPassword)}, [showPassword])

  const handleAuth = async () => {
    if (signType.type === 'IN')
      // login
      try {
        const res = await request(`${config.API_URL}api/login`, 'POST', {
          email:      credentials.email,
          password:   credentials.password
        })
        // console.log('res', res);
        auth.login(res.user.id, res.user.usertype_id, res.user.terminal_id, res.user);
        if (res.status) navigate(homeForRole(res.user?.usertype_id));
        else if (res.status === false && res.message === 'User not found') {
          setPopup({show: true, message: 'User not found'})
        }
        else if (res.status === false && res.message === 'Wrong password') {
          setPopup({show: true, message: 'Wrong password'})
        }
        else setPopup({show: true, message: res.message})
      } catch (err) {
        console.error(err)
        setPopup({show: true, message: err.message}) 
      }
    else if (signType.type === 'UP'){
      // registration
      if (credentials.password !== signupData.password) {
        setPopup({show: true, message: 'Check passcode in the fields \'Password\' & \'Repeat password\''})
        return;
      }
      if (needsTerminal && !terminal?.id) {
        setPopup({show: true, message: 'Select FBO'});
        return;
      }
      try {
        if (prefilledEmail) {
          // invited user: complete registration (set password)
          await request(`${config.API_URL}api/user/register`, 'POST', {
            firstname: signupData.firstName,
            lastname: signupData.lastName,
            ...(needsTerminal ? { terminal_id: terminal.id } : {}),
            invite: invitation,
            email: credentials.email,
            password: credentials.password
          });
          setPopup({show: true, message: 'Password set. You can now sign in.'});
          setSignType({type:'IN', messageBtn:'Sign in', messageChangeType:'Sign up'});
          setCredentials({ email: credentials.email, password: '' });
          setSignupData({ firstName:'', lastName:'', terminal:'', password:'' });
          return;
        } else {
          const res = await request(`${config.API_URL}api/user`, 'POST', {
            firstname: signupData.firstName,
            lastname: signupData.lastName,
            terminal_id: terminal.id,
            email:      credentials.email,
            password:   credentials.password
          })
          // console.log('res', res);
          if(res.status) setPopup({show: true, message: 'Please wait for confirmation Email and sign in'})
          else setPopup({show: true, message: 'Something magic happened / Try to sign in or sign up again'})
          return;
        }
      } catch (err) {
        console.error(err)
        setPopup({show: true, message: err.message})
      }
    }
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleAuth(); 
    }
  };
  const [popup, setPopup] = useState({show:false, message:''})
  const closePopup = () => {
    setPopup({show:false, message:''})
  }

  const [signType, setSignType] = useState({type:'IN', messageBtn:'Sign in', messageChangeType:'Sign up'})
  const changeSignType = () => {
    // console.log('signType:', signType)
    switch (signType.type){
      case 'IN':
        setSignType({type:'UP', messageBtn:'Sign up', messageChangeType:'Sign in'})
        break;
      case 'UP':
        setSignType({type:'IN', messageBtn:'Sign in', messageChangeType:'Sign up'})
        break;
      default:
        setSignType({type:'IN', messageBtn:'Sign in', messageChangeType:'Sign up'})
    }
  }

  const [terminalList, setTerminalList] = useState([])
  const getTerminalList = useCallback(async () => {
    try {
      const res = await request(`${config.API_URL}api/terminal`, 'GET')
      // console.log('res', res);
      setTerminalList(res)
    } catch (err) {
      console.error(err)
      setPopup({show: true, message: err.message})
    }
  }, [request])
  useEffect(()=>{
    if(signType.type === 'UP' && needsTerminal && !invitation) getTerminalList();
  }, [signType.type, needsTerminal, invitation, getTerminalList])

  const dd_style = {
    display: signType.type === 'UP' && needsTerminal ? 'flex' : 'none',
    width:`calc(${windowSize.width}px - 35px)`,
    maxWidth:'300px',
    margin:'0 20px 15px',
    padding:'16px 30px 16px 35px',
    border:'0',
    borderRadius:'32px',
    overflow:'hidden', 
    backgroundColor: '#F6EFE6',
    fontSize:'14px', color:'№606060'
  }
  const [terminal, setTerminal] = useState({})
  const handleOption = (event) => {
    setTerminal(terminalList.find(item => item.id === event.target.value*1) || {})
  }

  // Prefill from invitation link
  useEffect(() => {
    const emailParam = searchParams.get('email');
    if (!emailParam) return;
    setSignType({type:'UP', messageBtn:'Sign up', messageChangeType:'Sign in'});
    setCredentials((prev) => ({ ...prev, email: emailParam }));
    setPrefilledEmail(emailParam);
    const fetchUser = async () => {
      try {
        const userData = await request(`${config.API_URL}api/userbyemail?email=${encodeURIComponent(emailParam)}&invite=${encodeURIComponent(invitation)}`, 'GET');
        setInvitedRole(userData.usertype_id);
        if (userData?.firstname || userData?.lastname) {
          setSignupData((prev) => ({
            ...prev,
            firstName: userData.firstname || '',
            lastName: userData.lastname || ''
          }));
        }
        if (userData?.terminal_id?.length) {
          setInvitedTerminalId(userData.terminal_id[0]);
        }
      } catch (err) {
        console.error(err);
        setPopup({ show: true, message: err?.message || 'Failed to prefill data' });
      }
    };
    fetchUser();
  }, [request, searchParams, invitation]);

  // Set terminal after list is loaded
  useEffect(() => {
    if (!invitedTerminalId || !terminalList?.length) return;
    const t = terminalList.find(item => item.id === invitedTerminalId);
    if (t) setTerminal(t);
  }, [invitedTerminalId, terminalList]);
  // useEffect(()=>{console.log('terminal:', terminal)}, [terminal])

  return (
    <div style={{ 
      width:windowSize.width, 
      height:windowSize.height, 
      display: "flex",
      flexDirection:"column",
      alignItems:"center", 
      justifyContent:"center", 

      backgroundImage: 'url(../assets/image/home/home_bg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <Logo />
      <Popup setup={popup} onClose={()=>{closePopup()}} />
      <div style={{
        display: 'flex',
        width:'100%', height:`calc(${windowSize.height}px - 500px)`,
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center'
      }}>
        <input 
          className='light-brown input-login'
          style={{
            display: signType.type === 'UP' ? 'flex' : 'none',
            width:`calc(${windowSize.width}px - 105px)`,
            margin:'0 20px 15px',
            padding:'16px 30px 16px 35px',
            border:'0',
            borderRadius:'32px',
            overflow:'hidden', 
            fontSize:'14px', color:'№606060'
          }}
          name="firstName"
          type='text'
          placeholder="First Name"
          onChange={handleSignupChange}
          value={signupData.firstName}       
        />
        <input 
          className='light-brown input-login'
          style={{
            display: signType.type === 'UP' ? 'flex' : 'none',
            width:`calc(${windowSize.width}px - 105px)`,
            margin:'0 20px 15px',
            padding:'16px 30px 16px 35px',
            border:'0',
            borderRadius:'32px',
            overflow:'hidden', 
            fontSize:'14px', color:'№606060'
          }}
          name="lastName"
          type='text'
          placeholder="Last Name"
          onChange={handleSignupChange}
          value={signupData.lastName}       
        /> 
        <DropdownInput 
          selectedOption={terminal.id}
          list={terminalList}
          style={dd_style} 
          setOption={handleOption} 
        />
        <input 
          className='light-brown input-login'
          style={{
            width:`calc(${windowSize.width}px - 105px)`,
            margin:'0 20px 0',
            padding:'16px 30px 16px 35px',
            border:'0',
            borderRadius:'32px',
            overflow:'hidden', 
            fontSize:'14px', color:'№606060'
          }}
          name="email"
          type='email'
          placeholder="Email"
          onChange={handleChange}
          value={credentials.email}
          disabled={!!prefilledEmail}       
        />
        <div
          style={{ 
            position:'relative',
            width:`calc(${windowSize.width}px - 45px)`,
            maxWidth:'300px',
            margin:'15px 0 0'
          }}
        >
          <input 
            className='light-brown input-login'
            style={{
              width:`calc(100% - 65px)`,
              padding:'16px 30px 16px 35px',
              border:'0',
              borderRadius:'32px',
              overflow:'hidden', 
              fontSize:'14px', color:'№606060'
            }}
            name = "password"
            type = {showPassword ? "text" : "password"}
            placeholder="Password"
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            value={credentials.password}
          />
          <input 
            className='light-brown input-login'
            style={{
              display: signType.type === 'UP' && credentials.password ? 'flex' : 'none',
              width:`calc(100% - 65px)`,
              margin:'15px 0 0',
              padding:'16px 30px 16px 35px',
              border:'0',
              borderRadius:'32px',
              overflow:'hidden', 
              fontSize:'14px', color:'№606060'
            }}
            name = "password"
            type = {showPassword ? "text" : "password"}
            placeholder="Repeat password"
            onChange={handleSignupChange}
            onKeyDown={handleKeyDown}
            value={signupData.password}
          />
          <img 
            src={showPassword ? iconEyeClosed : iconEye} 
            onClick={handlePassMode} 
            style={{ position:'absolute', right:'14px', top:'11px', height:'24px', width:'24px', cursor:'pointer', opacity:'0.75' }}
          />
        </div>
      </div>
      <div style={{ width:"100%"}}>
        <div style={{ width:"300px", margin:"0 auto" }}>
          <p> 
            <span style={{color:"white", fontSize:"24px"}}>{'Manage your'}</span><br/>
            <span style={{color:"white", fontSize:"40px", fontWeight:"600"}}>{'Advertising Places'}</span>
          </p>
          <button className='button-main' style={{ width:"100%" }} onClick={handleAuth} onKeyDown={handleKeyDown} >{signType.messageBtn}</button>
          <div style={{ width:'100%', display: 'flex', justifyContent: 'center' ,alignItems: 'center' }}>
            <a href='#' style={{ marginTop: '30px', color: 'white', fontSize: 'small' }} onClick={()=>changeSignType()}>{signType.messageChangeType}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Splash;
